import React from "react";
import { PageTemplateProps } from "../common/PageTemplate";
import { ReclamationPlanningView } from "./erp/reclamation/planning/ReclamationPlanningView";

export interface TestPageProps extends PageTemplateProps {}

export const TestPage = React.memo(({}: TestPageProps) => {
	if (!import.meta.env.DEV) return null;

	return <ReclamationPlanningView
		reclamationIds={[3362, 5472, 5473]}
	/>;
});

export default TestPage;
